const fixApi = (data) => {
  if (data.guid) {
    data.id = data.guid
  }

  return data
}

export default fixApi
